import objectKeysToLowerCase from "./objectKeysToLowerCase";

interface IDirective {
    (source: any, ...params: string[]): string
}

// usage:
//               [variable] [directive] [directive parameter]
// interpolate('<h1>{title | transform | uppercase}</h1>',
//             { title: 'page title' },
//             {
//                  transform: (source, transformation) => {
//                      switch (transformation) {
//                          case 'uppercase': return source.toUpperCase();
//                          case 'lowercase': return source.toLowerCase();
//                          case 'invert': return source.split('').map(char => char === char.toUpperCase() ? char.toLowerCase() : char.toUpperCase());
//                          default: return source;
//                      }
//                  }
//             })
//
function interpolate(template: string, replacements: { [key: string]: any }, directives?: { [key: string]: IDirective }): string {
    return (template || "").replace(/\{([\w\d_]+(?:\s*\|[^}]+)*)\}/g, (match, expression) => {
        replacements = objectKeysToLowerCase(replacements);

        let variable = expression.split('|'),
            variableName = variable[0].trim().toLowerCase();

        let value = replacements[variableName];

        if (typeof(value) === 'function')
            value = value();

        directives = {...(interpolate as any).directives, ...directives};
        let directive = variable.length >= 2 && directives![variable[1].trim()];
        if (directive) {
            let params = variable.slice(2).map((param: string) => param.trim());
            value = directive.apply(variableName, [ value, ...params ]);
        }

        return value == null ? '' : value;
    });
}

(interpolate as any).directives = {
    uppercase: (source: string) => source ? source.toUpperCase() : source,
    lowercase: (source: string) => source ? source.toLowerCase() : source,
    escape: (source: string) => source ? encodeURIComponent(source) : source,
    mod: (source: string, modulus: string) => {
        const sourceNumber = Number(source);
        const modulusNumber = Number(modulus);

        if (Number.isNaN(sourceNumber) || Number.isNaN(modulusNumber) || modulusNumber <= 0) {
            return 0;
        }
        
       
        return sourceNumber % modulusNumber;
    }
};

export default interpolate;
